"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const ja_1 = __importDefault(require("date-fns/locale/ja"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const pickers_1 = require("@material-ui/pickers");
const date_fns_2 = require("date-fns");
const styles_1 = __importDefault(require("./styles"));
const MAX_MONTH = 3;
const MINUS_ONE_DAY = 1;
const mapLocales = {
    en: en_US_1.default,
    ja: ja_1.default,
};
const CalendarPicker = ({ disabledDays = [], date, onChange, keyLocale = 'ja', }) => {
    class PatchedDateFnsUtils extends date_fns_1.default {
        getCalendarHeaderText(stringDate) {
            return date_fns_2.format(stringDate, 'yyyy年MM月', { locale: this.locale });
        }
    }
    const classes = styles_1.default();
    const shouldDisableDate = react_1.useCallback((day) => disabledDays.includes(day.getDay()), [disabledDays]);
    const getMaxDate = () => {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth() + MAX_MONTH, today.getDate() - MINUS_ONE_DAY);
    };
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: PatchedDateFnsUtils, locale: mapLocales[keyLocale] },
        react_1.default.createElement("div", { className: classes.calendarContainer, "data-testid": "calendarPicker" },
            react_1.default.createElement(pickers_1.Calendar, { date: date, disablePast: true, onChange: onChange, shouldDisableDate: shouldDisableDate, maxDate: getMaxDate() }))));
};
exports.default = CalendarPicker;
